import './banner-service.scss';

/**
 * version    1.0
 * class      <type> (BannerService)
 * classdesc  Banner Service: contains one image bg, title, abstract, cta
 */
export class BannerService {}
